import { MatDialogConfig } from '@angular/material/dialog';

export const defaultModalConfig: MatDialogConfig = {
    panelClass: '__mobile-modal-padding',
};
